export default "__VITE_ASSET__eJCv1kdT__"